import React, { useState, useContext, useEffect } from "react";
import { IntlProvider } from "react-intl";
import styled, { css } from "styled-components";

import { createBrowserHistory } from "history";
import PAtabs from "../PAtabs";

import { gcRefunds } from './PAgkRefundSimple'
import { policies } from "./policies";

import { Link } from "react-router-dom";

import {
  CssTableLine,
  CssSwitchSub,
  CssTableCountry,
  CssTableFlag,
  CssTableDays,
  CssInputDay,
  SelectSquare,
  PAinfoCollapsible
} from "../uikit2";

import {
    InputCopy,
    FormGroup,
    Button,
    Select,
    Tooltip,
    StatusDot,
    Checkbox,
    Subheader,
    Pill,
    Slider,
    Radio,
    Breadcrumbs,
    Head,
    Card,
    Input,
    RadioGroup,
    Switch,
    Icon,
    ButtonAction,
    Tag,
    Notification,
    ContentBlock,
    FormCaption
} from 'xsolla-uikit';
import PAh2 from "../PAh2";
import CardNew from "../PAcardNew";

import { gcCountries } from "../../data/countries";

import PAContentBlock from "../PAContentBlock";
import { PArefundsBadge } from "./PArefundsBadge";
import { PArefundLevelSelect } from "./PArefundLevelSelect";
import { PArefundHint, PArefundHintText } from './PArefundHint';
import { PArefundPreview } from "./PArefundPreview";
import { xsollaProducts } from '../../data/xsollaProducts';

export default function PAgkRefund({
  products = [{
    product: 'game_store',
    level: 'loyal',
  },
  {
    product: 'subscriptions',
    // level: 'moderate',
    level: 'loyal',
  },{
    product: 'currency',
    level: 'loyal',
    // level: 'strict',
  },{
    product: 'simple_checkout',
    level: 'loyal',
  },
],
  showAsPage = true
}) {


  return (
    <div>
      {/* <PArefundHint opened={false}/> */}

    {/* <FormGroup indentation='lg' style={{position: 'relative', zIndex: 10}}>
      <PAh2 title="Fast&fair Refunds">
        <PArefundVersion/>
      </PAh2>
    </FormGroup> */}

            <PAContentBlock
              nopadding={products.length > 1 ? true : false}
              title="Refund policies"
              border='lg'
              // sticky="Strict policy"
            >

              <CSSrefunds0>
                {products.map((onePr, ind)=><ModuleRef product={onePr['product']} level={onePr['level']} key={`pr_${ind}`}/>)}
              </CSSrefunds0>


              <FormGroup>
                <div  className="l_flex"
                  style={{justifyContent: products.length > 1 ? 'center' : 'flex-starts'}}
                >
                  <Link to="/documents/refunds_edit">
                    <Button
                      appearance="secondary"
                      // appearance="outline-secondary"
                    >Configure</Button>
                  </Link>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                  {!!products.length && <Link to="/accounting/refunds_preview">
                    <Button appearance="flatten">Preview</Button>
                  </Link>}
                </div>
              </FormGroup>


            </PAContentBlock>


            <PAContentBlock
              // nopadding={true}
              title="Documents"
              border='lg'
              // sticky="Strict policy"
            >

              <FormGroup
                border={!!products.length ? 'lg' : false}
              >
                <FormGroup indentation='xs'>
                  <FormGroup indentation='xs'>
                    <StatusDot status="enabled">Active</StatusDot>
                  </FormGroup>

                  {!products.length && <b>Default refund policy</b>}
                  {!!products.length && <b>Loyal refund policy (Game store)</b>}

                  <p className="xsui-form-group__label">
                    Created: May 30, 2019
                  </p>
                  <FormGroup indentation='xs' style={{display: 'flex', marginLeft: -6}}>
                    <Link to="/accounting/refunds_preview"><Button appearance="flatten" style={{display: 'inline-flex'}}><Icon name='new-tab'/>Preview</Button></Link>&nbsp;&nbsp;&nbsp;&nbsp;
                    <Button appearance="flatten" style={{display: 'inline-flex'}}><Icon name='download'/>Download PDF</Button>
                  </FormGroup>
                </FormGroup>

              </FormGroup>

              {!!products.length && <FormGroup>
                <FormGroup indentation='xs'>
                  <StatusDot status="deactivated">Archived</StatusDot>
                </FormGroup>
                  <b>Strict refund policy (Game store, Currency)</b>
                  <p className="xsui-form-group__label">
                    Created: May 26, 2019
                  <br/>
                    Stopped: May 30, 2019
                  </p>
                <FormGroup indentation='xs' style={{display: 'flex', marginLeft: -6}}>
                  <Link to="/accounting/refunds_preview"><Button appearance="flatten" style={{display: 'inline-flex'}}><Icon name='new-tab'/>Preview</Button></Link>&nbsp;&nbsp;&nbsp;&nbsp;
                  <Button appearance="flatten" style={{display: 'inline-flex'}}><Icon name='download'/>Download PDF</Button>
                </FormGroup>
              </FormGroup>}



            </PAContentBlock>

            <PAContentBlock
              // nopadding={true}
              title="Info"
              // border={false}
              // sticky="Strict policy"
            >
              <PArefundHintText/>

            </PAContentBlock>

{/*
<FormGroup indentation="lg">
              <PArefundPreview
                // level={level}
              />
            </FormGroup> */}


    </div>
  );
}


export const PArefundPolicyDoc = ({
  active,
  level,
  border,
}) => {
  return(<FormGroup border={border} indentation={'lg'}>

                  <FormGroup indentation='xs'>
                    {active && <StatusDot status="enabled">Active</StatusDot>}
                    {!active && <StatusDot status="deactivated">Archived</StatusDot>}
                  </FormGroup>

                  {!level && <b>Default refund policy</b>}
                  {!!level && <b>{level} refund policy</b>}

                  <p className="xsui-form-group__label">
                    Created: May 30, 2019
                    {!active && <span>&nbsp;→&nbsp;Stopped: May 30, 2019</span>}
                  </p>
                  <FormGroup indentation='xs' style={{display: 'flex', marginLeft: -6}}>
                    <Link to="/accounting/refunds_preview"><Button appearance="flatten" style={{display: 'inline-flex'}}><Icon name='new-tab'/>Preview</Button></Link>&nbsp;&nbsp;&nbsp;&nbsp;
                    <Button appearance="flatten" style={{display: 'inline-flex'}}><Icon name='download'/>Download PDF</Button>
                  </FormGroup>

  </FormGroup>)
}



export const PArefundVersion = () => {
  return( <div
    style={{
      display: "flex",
      flexGrow: 1,
      alignItems: "center",
      justifyContent: "flex-end"
    }}
  >
    Policy version:&nbsp;
    <Select
      name={`vers`}
      align="right"
      size="sm"
      icon="redo"
      // placeholder={}
      input={{
        value: 1,
        name: "test",
        icon: "redo",
        // value: 'all',
        placeholder: "df"
        // onChange: this.setValue
      }}
      options={[
        {
          value: 1,
          label: <span>May 2, 2019 → Now</span>,
          extraLabel: "CURRENT"
        },
        {
          value: 2,
          label: <span>Jan 1, 2019 → May 2, 2019</span>
        }
      ]}
      // autosize={true}
      // size="xs"
    />
  </div>
  )
}


const CSSrefunds0 = styled.div`
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(460px, 570px));
    place-content: center;
    grid-column-gap: 44px;
    grid-row-gap: 44px;
    margin-bottom: 44px;

`






export const ModuleRef = ({
  product = 'game_store',
  editMode = false,
  level = 'loyal',
}) => {
  // const [level, setLevel] = useState("loyal");
  return (
    <ContentBlock
      // appearance="flatten"
      >
      {/* <PAContentBlock
               title="Game store"
               border={'lg'}
               // border={true}
               // sticky="Strict policy"
             > */}
{/* <CardNew wave={false}> */}
    <FormGroup indentation="lg">
        {/* <ContentBlock appearance="flatten"> */}
          {/* <FormGroup indentation="lg"> */}

              <FormGroup>
                <PAh2 tag='h3' title={xsollaProducts[product]["name"]} indentation={'xs'}>
                  <Pill appearance={policyTypes[level]['pill']}>{policyTypes[level]['title']} refund policy</Pill>
                </PAh2>
              </FormGroup>

              {/* <FormGroup
                indentation="md"
                label=""
              >
                <PArefundLevelSelect level={level} handleChange={setLevel} staticLevel={level} />
              </FormGroup> */}


              <FormGroup indentation="lg" label="Policy highlights">
                {gcRefunds.map((oneRef, ind) => {
                  return (
                    <FormGroup key={`onereason_${ind}`} indentation="xs">
                      {/* <PAh2 title={oneRef['title']} tag="h4" /> */}
                      <div indentation="xs">
                        <div className="l_flex">
                          <Icon
                            name={
                              policies[product]['presets'][level]["reasons"].indexOf(oneRef["id"]) >
                              -1
                                ? "checkmark"
                                : "block"
                            }
                          />
                          &nbsp;
                          <b
                            style={
                              {
                                // opacity: policies[level]['reasons'].indexOf(oneRef['id']) > -1 ? 1 : 0.3
                              }
                            }
                          >
                            {oneRef["title"]}
                          </b>
                        </div>
                      </div>
                    </FormGroup>
                  );
                })}
              </FormGroup>


              {/* Inside */}
              {/* <FormGroup border="lg">
                <div  className="l_flex">
                  <Link to="/documents/refunds_edit">
                    <Button appearance="outline-secondary">Configure</Button>
                  </Link>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                  <Link to="/accounting/refunds_preview">
                    <Button appearance="flatten">Preview </Button>
                  </Link>
                </div>
              </FormGroup> */}

              <FormGroup indentation="lg">
                <PArefundsBadge level={level} />
              </FormGroup>


          {/*  </FormGroup> */}
        {/*  </ContentBlock> */}
      </FormGroup>
            {/* </PAContentBlock> */}
    </ContentBlock>
  )
}



export const policyTypes = {
  loyal: {
    id: 'loyal',
    title: 'Loyal',
    pill: 'active',
    tooltip: 'Recommended',
  },
  moderate: {
    id: 'moderate',
    title: 'Moderate',
    pill: 'warning',
  },
  strict: {
    id: 'strict',
    title: 'Strict',
    pill: 'error',
    tooltip: 'Not recommended',
  },
}





const CssPreset = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

const CssEmoji = styled.div`
  background: #ffffff;
  border-radius: 100px;
  text-align: center;
  padding: 2px 0 0 4px;
  font-size: 13px;
  min-height: 22px;
  min-width: 22px;
`;

export const getCountries = () => {
  return gcCountries.map((oneCountry, ind) => ({
    label: (
      <CssTableCountry>
        <CssTableFlag>{oneCountry["icon"]}</CssTableFlag>
        {oneCountry["name"]}
      </CssTableCountry>
    ),
    value: ind
  }));
};
